import { render, staticRenderFns } from "./blockUser.vue?vue&type=template&id=2b56f1d3&scoped=true&"
import script from "./blockUser.vue?vue&type=script&lang=js&"
export * from "./blockUser.vue?vue&type=script&lang=js&"
import style0 from "./blockUser.vue?vue&type=style&index=0&id=2b56f1d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56f1d3",
  null
  
)

export default component.exports